import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  DialogActions,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Fab,
  Avatar,
  AppBar,
  Toolbar
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { IconBriefcase, IconBulb, IconDots, IconDotsVertical, IconFile, IconHeadset, IconLayoutDashboard, IconLogout2, IconPower, IconReceipt, IconReceiptDollar, IconShareplay, IconX } from "@tabler/icons-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Components/Images/logo-dark.png"
import profileImage from '.././Images/profile.jpg'
import Cookies from 'js-cookie';
const Sidebar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isMobile);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openpopup, setpopupopen] = useState(false)
  const location = useLocation();     
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(!isMobile);
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [isMobile]);

  const menuItems = [
    { text: "Dashboard", icon: <IconLayoutDashboard />, paths: ["/dashboard",'/documents','/viewdocument','/myprofile'] },
    { text: "Business Ideas", icon: <IconBulb />, paths: ["/create"] },
    { text: "Plans", icon: <IconReceipt />, paths: ["/plans" ]},
    { text: "Support", icon: <IconHeadset />, paths: ['/support','/support/createticket'] },
  ];
  const [userInfo, setuserInfo] = useState(() => {
  const cookieData = Cookies.get('user-info');
  return cookieData ? JSON.parse(cookieData) : null;
});
  
  const [anchorEl, setAnchorEl] = useState(null);
  useEffect(() => {
  const interval = setInterval(() => {
    const cookieData = Cookies.get('user-info');
    const userinfo = cookieData ? JSON.parse(cookieData) : null;
    setuserInfo(userinfo);
  }, 1000); // you can increase interval to 1000ms to reduce load

  return () => clearInterval(interval); // cleanup to prevent memory leaks
}, []);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    navigate('/')
    sessionStorage.removeItem("user-info");
    sessionStorage.removeItem("AdminToken");
    Cookies.remove("user-info")
    Cookies.remove("AdminToken");
  };

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setOpen(!open);
    }
  };

  return (
    <>
      {isMobile && !mobileOpen && (
        <AppBar position="fixed" sx={{ backgroundColor: "#fff", zIndex: theme.zIndex.drawer + 1,boxShadow:0 ,borderBottom: "1px solid #d9d9d9" }}>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <img src={logo} alt="Logo" style={{ height: "40px" }} />
            <IconButton onClick={handleDrawerToggle} sx={{ color: "#c53131" }}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      )}

      {(isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              width: 270,
              backgroundColor: "#fff",
              borderRight: "none",
              borderRadius: "0px 15px 15px 0px"
            },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
            {(open || mobileOpen) && (<img src={logo} alt="Logo" style={{ width: "180px", transition: "width 0.3s ease-in-out" }} />)}
            <IconButton onClick={handleDrawerToggle} sx={{ color: "#fff" }}>
              <MenuIcon />
            </IconButton>
          </Box>
          <List sx={{ p: 1 }}>
            {menuItems.map((item, index) => {
              // const isActive = location.pathname === item.path;
              const isActive = item.paths.some( path => location.pathname === path || location.pathname.startsWith(path + "/"));
              return (
                <ListItem
                  button
                  key={index}
                  component={Link}
                  to={item.paths[0]}
                  onClick={() => {
                    if (isMobile) setMobileOpen(false);
                  }}
                  sx={{
                    mb: 1,
                    cursor: "pointer",
                    backgroundColor: isActive ? "#c53131" : "transparent",
                    fontWeight: isActive ? "600" : "normal",
                    "&:hover": {
                      backgroundColor: "#c53131",
                      color: "#ff893f",
                    },
                    transition: "background-color 0.3s ease",
                    borderRadius: "8px",
                    listStyleType: "none",
                    "&::before": {
                      display: "none !important",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: isActive ?"#fff":"#000", fontWeight: isActive ? "600" : "normal", minWidth: "42px" }}>
                    {item.icon}
                  </ListItemIcon>
                  {(open || mobileOpen) && (
                    <ListItemText sx={{ color: isActive ?"#fff":"#000", fontWeight: isActive ? "600" : "normal" }}>
                      {item.text}
                    </ListItemText>
                  )}
                </ListItem>
              );
            })}
          </List>

          {(open || mobileOpen) && userInfo && (
            <Box sx={{ display: "flex", alignItems: "center", background: "#c53131", borderRadius: "10px", p: 1, mt: "auto", mr: 2, mx: 2, mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                  sx={{
                    width: 40,
                    height: 40,
                    background: "#fff",
                    color: "#000",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px"
                  }}
                >
                  <Avatar
                    src={profileImage} 
                    alt={userInfo?.fullname}
                    sx={{ width: 40, height: 40 }}
                  />
                </Box>

                <Box onClick={() => navigate('/myprofile')}>
                  <Typography variant="body1" fontWeight="bold" color="#fff">
                    {userInfo.fullname}
                  </Typography>
                  <Tooltip title={userInfo.email} arrow>
                    <Typography variant="body2" fontWeight="bold" color="#fff" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "140px", cursor: "pointer" }}>
                      {userInfo.email.length > 18 ? `${userInfo.email.slice(0, 18)}...` : userInfo.email}
                    </Typography>
                  </Tooltip>
                </Box>

                
              </Box>

              <IconButton sx={{ color: "#fff" }} onClick={handleClick} id="profile-menu-button">
                <IconDotsVertical />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem onClick={() => { handleClose(); navigate('/myprofile') }}>
                  My Profile
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); navigate('/plans/transactionhistory') }}>
                  Billing
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); setpopupopen(true) }}>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Drawer>
      ) : (
        <Drawer variant="permanent" sx={{
          width: open ? 270 : 60,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? 270 : 60,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            backgroundColor: "#fff",
            // borderRight: "1px solid #d9d9d9",
            // borderRadius: "0px 15px 15px 0px"
          }
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
            {open && (<img src={logo} alt="Logo" style={{ width: "180px", transition: "width 0.3s ease-in-out" }} />)}
            <IconButton onClick={handleDrawerToggle} sx={{ color: "#c53131" }}>
              <MenuIcon />
            </IconButton>
          </Box>
          <List sx={{ p: 1 }}>
            {menuItems.map((item, index) => {
              // const isActive = location.pathname === item.path;
              const isActive = item.paths.some( path => location.pathname === path || location.pathname.startsWith(path + "/"));
              return (
                <ListItem
                  button
                  key={index}
                  component={Link}
                  to={item.paths[0]}
                  // onClick={() => navigate(item.path)}
                  sx={{
                    mb: 1,
                    cursor: "pointer",
                    backgroundColor: isActive ? "#c53131" : "transparent",
                    fontWeight: isActive ? "600" : "normal",
                    "&:hover": {
                      backgroundColor: isActive? "#c53131":"#efa1a2",
                      color: "#fff",
                    },
                    transition: "background-color 0.3s ease",
                    borderRadius: "8px",
                    listStyleType: "none",
                    "&::before": {
                      display: "none !important",
                    },
                    paddingLeft:open ? "16px" : "10px",
                  }}
                >
                  <ListItemIcon sx={{ color: isActive ? "#fff":"#000", fontWeight: isActive ? "600" : "normal", minWidth: "42px"}}>
                    {item.icon}
                  </ListItemIcon>
                  {open && (
                    <ListItemText sx={{ color: isActive ? "#fff":"#000", fontWeight: isActive ? "600" : "normal" }}>
                      {item.text}
                    </ListItemText>
                  )}
                </ListItem>
              );
            })}
          </List>

          {open && userInfo && (
            <Box sx={{ display: "flex", alignItems: "center", background: "#c53131", borderRadius: "10px", p: 1, mt: "auto", mr: 2, mx: 2, mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    background: "#fff",
                    color: "#000",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px"
                  }}
                >
                  <Avatar
                    src={profileImage} 
                    alt={userInfo?.fullname}
                    sx={{ width: 40, height: 40 }}
                  />
                </Box>

                <Box onClick={() => navigate('/myprofile')}>
                    <Typography variant="body1" fontWeight="bold" color="#fff">
                      {userInfo?.fullname}
                    </Typography>
                  <Tooltip title={userInfo?.email} arrow>
                    <Typography variant="body2" fontWeight="bold" color="#fff" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "140px", cursor: "pointer" }}>
                      {userInfo?.email?.length > 18 ? `${userInfo?.email?.slice(0, 18)}...` : userInfo?.email}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>

              <IconButton sx={{ color: "#fff" }} onClick={handleClick} id="profile-menu-button">
                <IconDotsVertical />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem onClick={() => { handleClose(); navigate('/myprofile') }}>
                  My Profile
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); navigate('/plans/transactionhistory') }}>
                  Billing
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); setpopupopen(true) }}>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Drawer>
      ))}

      <Dialog open={openpopup} onClose={() => setpopupopen(false)} fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Confirm Logout
          <IconButton onClick={() => setpopupopen(false)}>
            <IconX size={24} />
          </IconButton>
        </DialogTitle>
        <Divider />

        <DialogContent sx={{ textAlign: "center" }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <IconButton sx={{ backgroundColor: "#ffe7da", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
              <IconLogout2 color="#f5945c" size={50} />
            </IconButton>
          </Box>
          Are you sure you want to logout?
        </DialogContent>
        <Divider />
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button onClick={() => setpopupopen(false)} color="primary" variant="contained">
            Cancel
          </Button>
          <Button onClick={handleLogout} color="error" variant="contained">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Sidebar;